import React from "react";
import { Anchor, Check } from "lucide-react";

const VALUES = ["Wachstum", "Innovation", "Vertrauen", "Klarheit", "Dynamik", "Professionalität"];
const POINTS = [
  "Strategie, die zur Marke passt – nicht zum Trend",
  "In-House-Produktion statt Stockfoto-Fließband",
  "Reportings, die du auch ohne BWL-Studium verstehst",
  "Direkter Draht zum Team – kein Account-Manager-Pingpong",
];

export default function About() {
  return (
    <section id="ueber-uns" data-testid="about-section" className="hh-section bg-white relative overflow-hidden">
      {/* decorative blue wave */}
      <svg
        aria-hidden
        className="absolute -left-10 top-0 opacity-10"
        width="380"
        height="160"
        viewBox="0 0 380 160"
        fill="none"
      >
        <path d="M0 80 Q 60 30, 120 80 T 240 80 T 380 80" stroke="#2185D0" strokeWidth="6" fill="none" />
        <path d="M0 120 Q 60 70, 120 120 T 240 120 T 380 120" stroke="#2185D0" strokeWidth="6" fill="none" />
      </svg>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        {/* Image */}
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-[28px] overflow-hidden border border-[#ECECEC]">
            <img
              src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
              alt="Hype Hafen Team in einem Strategie-Meeting"
              className="w-full h-[520px] object-cover"
            />
          </div>
          {/* Yellow accent block */}
          <div className="absolute -bottom-6 -right-6 bg-[#FFF44F] rounded-2xl p-5 w-52 shadow-lg" data-testid="about-badge">
            <Anchor className="w-6 h-6 text-[#2E2E2E] mb-3" />
            <div className="font-display text-[#2E2E2E] text-lg leading-tight">Hamburg.<br/>Digital. Direkt.</div>
          </div>
          {/* Blue circle accent */}
          <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 rounded-full bg-[#2185D0]" />
        </div>

        {/* Copy */}
        <div className="lg:col-span-7">
          <div className="hh-eyebrow mb-5">Über uns</div>
          <h2 className="hh-headline text-[2.3rem] sm:text-[3rem] lg:text-[3.6rem] text-[#2E2E2E]">
            Marketing, das <span className="hh-highlight">Kurs hält.</span>
          </h2>
          <p className="font-body text-[#2E2E2E]/75 text-base sm:text-lg leading-relaxed mt-6 max-w-2xl">
            Hype Hafen ist die Social Media Agentur in Hamburg für KMU, lokale Dienstleister,
            Coaches und E-Commerce Brands. Wir verbinden klare Strategie mit scharfem Content
            und konsistenter Umsetzung – mit Fokus auf organisches Wachstum, damit du nicht
            mehr vom Algorithmus abhängig bist, sondern System auf deine Sichtbarkeit setzt.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3" data-testid="about-points">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 font-body text-[0.95rem] text-[#2E2E2E]">
                <span className="mt-1 w-5 h-5 rounded-full bg-[#FFF44F] flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-[#2E2E2E]" strokeWidth={3} />
                </span>
                {p}
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <div className="font-display text-[0.72rem] tracking-[0.22em] uppercase text-[#2E2E2E]/60 mb-4">Unsere Werte</div>
            <div className="flex flex-wrap gap-2">
              {VALUES.map((v, i) => (
                <span
                  key={v}
                  data-testid={`value-pill-${i}`}
                  className="hh-pill"
                  style={{
                    border: i % 3 === 0 ? "1.5px solid #2E2E2E" : i % 3 === 1 ? "1.5px solid #2185D0" : "1.5px solid #FFF44F",
                    color: i % 3 === 1 ? "#2185D0" : "#2E2E2E",
                    background: i % 3 === 2 ? "#FFF44F" : "transparent",
                  }}
                >
                  {v}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
